import {Component, EventEmitter, Input, NgModule, Output} from '@angular/core';
import {UntypedFormGroup, ReactiveFormsModule} from '@angular/forms';
import {SelectFilterElement} from '../../../../../../../components/common/select-filter/select-filter.model';
import {CommonModule} from '@angular/common';
import {SelectFilterDataModule} from '../../../../../../core/component/select-filter-data/select-filter-data.module';
import {FormDefinitionFormSummaryModel} from '../../entity/formDefinitionFormSummary.model';
import {FormDefinitionFormSummaryFindAllService} from '../../../impl/service/formDefinitionFormSummaryFindAll.service';

@Component({
    selector: 'app-form-definition-form-select-filter',
    template: `
        <app-select-filter-data
                [filterElementProcessor]="filter"
                [findAllService]="findAllService"
                [parentFormControlName]="parentFormControlName"
                [parentFormGroup]="parentFormGroup"
                [resolveSelectFilterElement]="resolveSelectFilterElement"
                (selectionChanged)="selectionChangedEvent.emit($event?.element)">
            <ng-template let-element='element' template-content>
                {{element.label}}
            </ng-template>
        </app-select-filter-data>
    `
})
export class FormDefinitionFormSelectFilterComponent{

    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() findAllService: FormDefinitionFormSummaryFindAllService;
    @Output() selectionChangedEvent = new EventEmitter<FormDefinitionFormSummaryModel>();

    constructor() {
    }

    filter = (criteria: string, entity: FormDefinitionFormSummaryModel) => {
        return (entity.label).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    resolveSelectFilterElement = (entity: FormDefinitionFormSummaryModel): SelectFilterElement<number, FormDefinitionFormSummaryModel> => {
        return new SelectFilterElement(entity.id, entity.id, entity);
    }

}

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectFilterDataModule,
    ],
    declarations: [
        FormDefinitionFormSelectFilterComponent
    ],
    exports: [
        FormDefinitionFormSelectFilterComponent
    ]
})
export class FormDefinitionFormSelectFilterModule {
}
